import { render, staticRenderFns } from "./AccountDepositModal.vue?vue&type=template&id=0a46f1e2"
import script from "./AccountDepositModal.vue?vue&type=script&lang=js"
export * from "./AccountDepositModal.vue?vue&type=script&lang=js"
import style0 from "./AccountDepositModal.vue?vue&type=style&index=0&id=0a46f1e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports